import { render } from "./CustodyPopup..vue?vue&type=template&id=80006d38&scoped=true"
import script from "./CustodyPopup..vue?vue&type=script&lang=js"
export * from "./CustodyPopup..vue?vue&type=script&lang=js"

import "./CustodyPopup..vue?vue&type=style&index=0&id=80006d38&lang=scss&scoped=true"

import exportComponent from "C:\\xiangmu\\gas-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80006d38"]])

export default __exports__